import type { ReactElement, ReactNode } from 'react';
import styles from './SplitLayout.module.scss';

/**
 * Раскладка страницы из двух колонок. На телефоне и планшете — одна колонка, от lg — две:
 * - content — основное (3 доли) и боковая колонка (2 доли): пост, пакет публикации;
 * - media — узкая колонка превью (до 360 px) и сведения: карточка медиа.
 */
export function SplitLayout({ variant = 'content', children }: { variant?: 'content' | 'media'; children: [ReactNode, ReactNode] }): ReactElement {
  return (
    <div className={`${styles.split} ${styles[variant]}`}>
      <div className={styles.column}>{children[0]}</div>
      <div className={styles.column}>{children[1]}</div>
    </div>
  );
}
